module.exports = __webpack_public_path__ + "static/img/5080_phase_function_Paper_Points.0110c30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5080_phase_function_Paper_Points.png
// module id = fsGH
// module chunks = 0